import RelatorioEmDesenvolvimento from "../../../components/RelatorioEmDesenvolvimento";

const OrcamentoRealiz = () => (
  <RelatorioEmDesenvolvimento
    titulo="Orçado vs. Realizado"
    descricao="Vai depender de um módulo de orçamento por categoria/centro de custo, que ainda não existe."
  />
);

export default OrcamentoRealiz;
